// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"091baebd","610":"7e22ba03","895":"632e1ccd"}[chunkId] + ".chunk.js";
};